// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"677":"04dd98001228743d1857","6394":"5f4f2f43b45397b0b596","7230":"d45df3c3b9f978200bf5","9636":"ea49c7c324908115f468"}[chunkId] + ".js";
};